// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_edit.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__depositViewContainer___xnnfp {
  display: flex;
  gap: 0;
  margin-left: -20px;
  max-width: 970px;
}

.styles__depositCard___gQOwm {
  position: relative;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]};
  width: 100%;
}

.styles__orange___e1GPQ {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtAmber"]};
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 4px;
  line-height: 1.2;
  height: 15px;
  display: flex;
  align-items: flex-end;
}

.styles__depositCardWrapper___QXOqj {
  padding: 24px 32px 32px;
  background-color: white;
}

.styles__depositMainGrid___qypTV {
  display: grid;
  grid-template-columns: 120px 1fr 220px;
  grid-gap: 60px;
  gap: 60px;
  align-items: start;
  justify-content: space-between;
  width: 100%;
}

.styles__depositTypeColumn___rfa2p {
  display: flex;
  flex-direction: column;
  padding-right: 16px;
  justify-self: start;
}

.styles__depositTypeLabel___xDVw4 {
  font-size: 20px;
  font-weight: 200;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  margin-bottom: 48px;
  margin-top: 7px;
  line-height: 1;
  white-space: nowrap;
}

.styles__infoItem___rgYSo {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  height: 46px;
}

.styles__infoLabel___iQmfm {
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 4px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  line-height: 1.2;
  height: 15px;
  display: flex;
  align-items: flex-end;
}

.styles__infoValue___CSpMd {
  font-size: 18px;
  font-weight: 700;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
  line-height: 1.1;
  flex: 1;
  display: flex;
  align-items: flex-start;
}

.styles__accountColumn___I5ZeV {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  justify-self: center;
  text-align: left;
  margin-top: 7px;
}

.styles__accountColumn___I5ZeV .styles__infoItem___rgYSo {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  height: 46px;
}

.styles__accountColumn___I5ZeV .styles__infoLabel___iQmfm {
  justify-content: flex-start;
  text-align: left;
}

.styles__accountColumn___I5ZeV .styles__infoValue___CSpMd {
  text-align: left;
}

.styles__depositTypeColumn___rfa2p .styles__infoItem___rgYSo {
  align-items: flex-start;
}

.styles__depositTypeColumn___rfa2p .styles__infoLabel___iQmfm {
  justify-content: flex-start;
}

.styles__transferInfo___wXTwE {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 0;
}

.styles__transferLabel___can9x {
  font-size: 12px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtOrangeDark"]};
  font-weight: 400;
  margin-bottom: 4px;
  line-height: 1.2;
  height: 15px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
}

.styles__transferValue___mtwXn {
  font-size: 18px;
  font-weight: 700;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
  line-height: 1.1;
  text-align: left;
}

.styles__feeColumn___NLkHV {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-self: end;
  width: 100%;
}

.styles__feeBalanceInfo___cAlmO {
  margin-bottom: 24px;
  text-align: right;
  height: 46px;
  display: flex;
  flex-direction: column;
}

.styles__feeBalanceLabel___t0ztq {
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 4px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
  line-height: 1.2;
  height: 15px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.styles__feeBalanceValue___ch33b {
  font-size: 16px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
  line-height: 1.1;
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  text-align: right;
}

.styles__feeGrid___k9fyg {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 24px;
  width: 100%;
  justify-content: flex-end;
  align-self: flex-end;
}

.styles__feeGridItem___NzXgz {
  text-align: center;
  min-width: 80px;
}

.styles__feeGridLabel___q0Tkb {
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 4px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
  line-height: 1.2;
  text-align: right;
  height: 15px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.styles__feeGridValue___cbaRk {
  font-size: 16px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
  line-height: 1.1;
  text-align: right;
}

.styles__specialNotice___wI3dE {
  font-size: 14px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtOrangeDark"]};
  font-style: italic;
  text-align: right;
  line-height: 1.2;
}

.styles__editButton___zLcWW {
  display: flex;
  height: 50px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  font-weight: 600;
  justify-content: flex-start;
  align-items: center;
  box-shadow: none;
  padding-right: 16px;
  border: none;
  border-bottom: 1px solid gtGrayLight;
  background: transparent;
  cursor: pointer;
}

.styles__editButton___zLcWW::before {
  content: '';
  height: 100%;
  width: 36px;
  margin-bottom: 6px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 16px;
}

.styles__editButton___zLcWW:hover {
  box-shadow: none;
  background: gtGrayLight;
  -webkit-text-decoration: underline;
  text-decoration: underline;
}

@media (max-width: 1400px) {
  .styles__depositMainGrid___qypTV {
    grid-template-columns: 110px 1fr 200px;
    gap: 50px;
  }

  .styles__feeGrid___k9fyg {
    grid-template-columns: 65px 90px 90px;
    gap: 14px;
  }
}

@media (max-width: 1024px) {
  .styles__depositMainGrid___qypTV {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .styles__depositTypeColumn___rfa2p,
  .styles__accountColumn___I5ZeV {
    padding-right: 0;
  }

  .styles__accountColumn___I5ZeV {
    text-align: left;
    padding: 0;
  }

  .styles__accountColumn___I5ZeV .styles__infoItem___rgYSo,
  .styles__accountColumn___I5ZeV .styles__infoLabel___iQmfm {
    align-items: flex-start;
    justify-content: flex-start;
  }

  .styles__feeColumn___NLkHV {
    align-items: flex-start;
  }

  .styles__feeHeader___yqWIb,
  .styles__feeBalanceInfo___cAlmO,
  .styles__specialNotice___wI3dE {
    text-align: left;
  }

  .styles__feeBalanceLabel___t0ztq,
  .styles__feeGridLabel___q0Tkb {
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .styles__depositCardWrapper___QXOqj {
    padding: 24px;
  }

  .styles__depositTypeLabel___xDVw4,
  .styles__feeHeader___yqWIb {
    font-size: 36px;
  }

  .styles__infoValue___CSpMd,
  .styles__transferValue___mtwXn,
  .styles__feeBalanceValue___ch33b,
  .styles__feeGridValue___cbaRk {
    font-size: 20px;
  }

  .styles__feeGrid___k9fyg {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .styles__feeGridItem___NzXgz {
    text-align: left;
  }

  .styles__feeGridLabel___q0Tkb {
    text-align: left;
    justify-content: flex-start;
  }

  .styles__feeGridValue___cbaRk {
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Deposit/Forms/view/styles.css"],"names":[],"mappings":"AAIA;EAEE,aAAa;EACb,MAAM;EACN,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8DAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mDAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,cAAS;EAAT,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mDAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mDAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mDAAe;EACf,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mDAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mDAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mDAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mDAAe;EACf,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mDAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mDAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mDAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mDAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yDAAiD;EACjD,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kCAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;EACE;IACE,sCAAsC;IACtC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;;IAEE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtCardHeaderBG, text, gtGrayMid, gtPurpleDark, textLight, gtGrayDark, textDark, gtOrangeDark, gtAmber from colors;\n\n.depositViewContainer {\n  composes: content-container from helpers;\n  display: flex;\n  gap: 0;\n  margin-left: -20px;\n  max-width: 970px;\n}\n\n.depositCard {\n  position: relative;\n  background-color: gtCardHeaderBG;\n  width: 100%;\n}\n\n.orange {\n  color: gtAmber;\n  font-size: 12px;\n  font-weight: 400;\n  margin-bottom: 4px;\n  line-height: 1.2;\n  height: 15px;\n  display: flex;\n  align-items: flex-end;\n}\n\n.depositCardWrapper {\n  padding: 24px 32px 32px;\n  background-color: white;\n}\n\n.depositMainGrid {\n  display: grid;\n  grid-template-columns: 120px 1fr 220px;\n  gap: 60px;\n  align-items: start;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.depositTypeColumn {\n  display: flex;\n  flex-direction: column;\n  padding-right: 16px;\n  justify-self: start;\n}\n\n.depositTypeLabel {\n  font-size: 20px;\n  font-weight: 200;\n  color: textLight;\n  margin-bottom: 48px;\n  margin-top: 7px;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.infoItem {\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  height: 46px;\n}\n\n.infoLabel {\n  font-size: 12px;\n  font-weight: 400;\n  margin-bottom: 4px;\n  color: text;\n  line-height: 1.2;\n  height: 15px;\n  display: flex;\n  align-items: flex-end;\n}\n\n.infoValue {\n  font-size: 18px;\n  font-weight: 700;\n  color: textDark;\n  line-height: 1.1;\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n}\n\n.accountColumn {\n  display: flex;\n  flex-direction: column;\n  padding: 0 20px;\n  justify-self: center;\n  text-align: left;\n  margin-top: 7px;\n}\n\n.accountColumn .infoItem {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 24px;\n  height: 46px;\n}\n\n.accountColumn .infoLabel {\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.accountColumn .infoValue {\n  text-align: left;\n}\n\n.depositTypeColumn .infoItem {\n  align-items: flex-start;\n}\n\n.depositTypeColumn .infoLabel {\n  justify-content: flex-start;\n}\n\n.transferInfo {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: 0;\n}\n\n.transferLabel {\n  font-size: 12px;\n  color: gtOrangeDark;\n  font-weight: 400;\n  margin-bottom: 4px;\n  line-height: 1.2;\n  height: 15px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.transferValue {\n  font-size: 18px;\n  font-weight: 700;\n  color: textDark;\n  line-height: 1.1;\n  text-align: left;\n}\n\n.feeColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-self: end;\n  width: 100%;\n}\n\n.feeBalanceInfo {\n  margin-bottom: 24px;\n  text-align: right;\n  height: 46px;\n  display: flex;\n  flex-direction: column;\n}\n\n.feeBalanceLabel {\n  font-size: 12px;\n  font-weight: 400;\n  margin-bottom: 4px;\n  color: textDark;\n  line-height: 1.2;\n  height: 15px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n\n.feeBalanceValue {\n  font-size: 16px;\n  color: textDark;\n  line-height: 1.1;\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  text-align: right;\n}\n\n.feeGrid {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  margin-bottom: 24px;\n  width: 100%;\n  justify-content: flex-end;\n  align-self: flex-end;\n}\n\n.feeGridItem {\n  text-align: center;\n  min-width: 80px;\n}\n\n.feeGridLabel {\n  font-size: 12px;\n  font-weight: 400;\n  margin-bottom: 4px;\n  color: textDark;\n  line-height: 1.2;\n  text-align: right;\n  height: 15px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n\n.feeGridValue {\n  font-size: 16px;\n  color: textDark;\n  line-height: 1.1;\n  text-align: right;\n}\n\n.specialNotice {\n  font-size: 14px;\n  color: gtOrangeDark;\n  font-style: italic;\n  text-align: right;\n  line-height: 1.2;\n}\n\n.editButton {\n  display: flex;\n  height: 50px;\n  color: text;\n  font-weight: 600;\n  justify-content: flex-start;\n  align-items: center;\n  box-shadow: none;\n  padding-right: 16px;\n  border: none;\n  border-bottom: 1px solid gtGrayLight;\n  background: transparent;\n  cursor: pointer;\n}\n\n.editButton::before {\n  content: '';\n  height: 100%;\n  width: 36px;\n  margin-bottom: 6px;\n  background-image: url('styles/img/icon_edit.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 16px;\n}\n\n.editButton:hover {\n  box-shadow: none;\n  background: gtGrayLight;\n  text-decoration: underline;\n}\n\n@media (max-width: 1400px) {\n  .depositMainGrid {\n    grid-template-columns: 110px 1fr 200px;\n    gap: 50px;\n  }\n\n  .feeGrid {\n    grid-template-columns: 65px 90px 90px;\n    gap: 14px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .depositMainGrid {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n\n  .depositTypeColumn,\n  .accountColumn {\n    padding-right: 0;\n  }\n\n  .accountColumn {\n    text-align: left;\n    padding: 0;\n  }\n\n  .accountColumn .infoItem,\n  .accountColumn .infoLabel {\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n\n  .feeColumn {\n    align-items: flex-start;\n  }\n\n  .feeHeader,\n  .feeBalanceInfo,\n  .specialNotice {\n    text-align: left;\n  }\n\n  .feeBalanceLabel,\n  .feeGridLabel {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 768px) {\n  .depositCardWrapper {\n    padding: 24px;\n  }\n\n  .depositTypeLabel,\n  .feeHeader {\n    font-size: 36px;\n  }\n\n  .infoValue,\n  .transferValue,\n  .feeBalanceValue,\n  .feeGridValue {\n    font-size: 20px;\n  }\n\n  .feeGrid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .feeGridItem {\n    text-align: left;\n  }\n\n  .feeGridLabel {\n    text-align: left;\n    justify-content: flex-start;\n  }\n\n  .feeGridValue {\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"gtGrayMid": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayMid"]}`,
	"gtPurpleDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtPurpleDark"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"textDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]}`,
	"gtOrangeDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtOrangeDark"]}`,
	"gtAmber": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtAmber"]}`,
	"depositViewContainer": `styles__depositViewContainer___xnnfp ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"depositCard": `styles__depositCard___gQOwm`,
	"orange": `styles__orange___e1GPQ`,
	"depositCardWrapper": `styles__depositCardWrapper___QXOqj`,
	"depositMainGrid": `styles__depositMainGrid___qypTV`,
	"depositTypeColumn": `styles__depositTypeColumn___rfa2p`,
	"depositTypeLabel": `styles__depositTypeLabel___xDVw4`,
	"infoItem": `styles__infoItem___rgYSo`,
	"infoLabel": `styles__infoLabel___iQmfm`,
	"infoValue": `styles__infoValue___CSpMd`,
	"accountColumn": `styles__accountColumn___I5ZeV`,
	"transferInfo": `styles__transferInfo___wXTwE`,
	"transferLabel": `styles__transferLabel___can9x`,
	"transferValue": `styles__transferValue___mtwXn`,
	"feeColumn": `styles__feeColumn___NLkHV`,
	"feeBalanceInfo": `styles__feeBalanceInfo___cAlmO`,
	"feeBalanceLabel": `styles__feeBalanceLabel___t0ztq`,
	"feeBalanceValue": `styles__feeBalanceValue___ch33b`,
	"feeGrid": `styles__feeGrid___k9fyg`,
	"feeGridItem": `styles__feeGridItem___NzXgz`,
	"feeGridLabel": `styles__feeGridLabel___q0Tkb`,
	"feeGridValue": `styles__feeGridValue___cbaRk`,
	"specialNotice": `styles__specialNotice___wI3dE`,
	"editButton": `styles__editButton___zLcWW`,
	"feeHeader": `styles__feeHeader___yqWIb`
};
export default ___CSS_LOADER_EXPORT___;
